module.exports = __webpack_public_path__ + "static/media/SiteEngineer.9519bfc4.jpg";